export default "__VITE_ASSET__Pe6Qd2dx__"